import styled from 'styled-components'
import { breakpoints } from '../../../styles/vars/breakpoints.style'
import { clamp } from '../../../styles/utils/conversion.style'
import { easings } from '../../../styles/vars/easings.style'
import { colors } from '../../../styles/vars/colors.style'
import { Label } from '../../../styles/vars/textStyles.style'
import { mq } from '../../../styles/vars/media-queries.style'

export const MapLocationImage = styled.div`
  border-radius: 50%;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  &:before {
    background-image: url(${props => props.image});
    background-size: cover;
    content: '';
    display: block;
    height: 100%;
    transform: scale(${props => (props.active ? 1.01 : 1.4)});
    transform-origin: 50% 50%;
    transition: transform ${props => (props.active ? `1s` : `0s`)}
      ${easings.out.quart};
    transition-delay: ${props => (props.active ? props.delay : `.5`)}s;
    width: 100%;
  }
`

export const MapLocationLabel = styled.div`
  background-color: ${colors.light};
  border-radius: 2.4rem;
  display: flex;
  align-items: center;
  left: 50%;
  opacity: 0;
  padding: 0.8rem;
  padding-right: 2.2rem;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: translateX(-50%) translateY(-100%);
  white-space: nowrap;

  &:before {
    background-color: ${colors.light};
    border-radius: 0.2rem;
    bottom: -0.4rem;
    content: '';
    height: 1rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%) rotateZ(45deg);
    width: 1rem;
  }

  ${Label} {
    display: block;
    margin-left: 1.1rem;
  }
`

export const MapLocationPin = styled.div``

export const MapLocationWrapper = styled.div`
  border-radius: 50%;
  box-shadow: 0px 10px 20px rgb(0 0 0 / 50%);
  height: 100%;
  opacity: ${props => (props.inView ? 1 : 0)};
  width: 100%;

  ${props =>
    props.inView &&
    `
    transition: opacity 2s ${easings.out.quart} 2s;
  `}
`

export const MapLocationOuter = styled.div`
  border-radius: 50%;
  ${clamp('height', 30, 50, breakpoints.desk, breakpoints.contained)};
  opacity: ${props => (props.active ? 1 : 0)};
  position: absolute;
  ${props => (props.left !== undefined ? `left: ${props.left}%;` : ``)}
  ${props => (props.top !== undefined ? `top: ${props.top}%;` : ``)}
  transform: translateX(-50%) translateY(-50%);
  transition: opacity ${props => (props.active ? `1s` : `0.5s`)}
    ${easings.out.quart};
  transition-delay: ${props => (props.active ? props.delay : `0`)}s;
  ${clamp('width', 30, 50, breakpoints.desk, breakpoints.contained)};
  z-index: 5;

  ${mq.desk} {
    &:hover {
      z-index: 6;

      ${MapLocationLabel} {
        opacity: 1;
        transform: translateX(-50%) translateY(-100%) translateY(-1.4rem);
        transition: transform 0.5s ${easings.out.quart},
          opacity 0.5s ${easings.out.quart};
      }
    }
  }
`
